<template>
	<div style="background: #fff;">
	<!-- <div class="xieyi-box">
		{{loginText}}
	</div> -->
	<el-dialog class="des-modal" :visible.sync="show" :width="widthNum" :show-close="false" title="提示" left>
		<div class="text-c">
			<img src="../../assets/serch_loading.gif" class="img" style="width: 60px;position:relative;top:4px;" />
			<p class="ft16 fn mt20 pb20">{{loginText}}</p>
		</div>
	</el-dialog>
   </div>
</template>
<script>
	
	import { getAccountInfo, setAccountInfo } from '@/utils/localdatas';
	var util = require('@/utils/util.js');
	var yqfCommon = require('@/utils/yqfCommon.js');
	var accountApi=require('@/api/account.js');
	var that;
	
	export default {
		components: {},
		data() {
			return {
				returnurl:'',
				code:'',
				loginText:'正在登录中...',
				widthNum:100,
				show:true
			}
		},
	    created() {
	    	that = this;
			var query = that.$route.query;
			console.log(query);
			
	    	// 中转页同样只允许本站内安全回跳地址。
	    	that.returnurl = util.sanitizeReturnUrl(query.returnurl, '/');
			that.code =query.code;
			console.log(getAccountInfo());
			// return;
			if(!yqfCommon.isNullOrEmpty(that.code)){
				GetLoginByUserCode();
			}
	    },
		mounted() {
			 console.log('当前地址：'+this.$route.path); 
			$(window).scrollTop("0");
		}
	}
	//根据账号登录
	function GetLoginByUserCode(){
		var parm={
			code:that.code
		};
		accountApi.GetLoginByUserCode(parm,function(result){
			console.log(result);
			if(result.code==0){
				setAccountInfo(result.data.accountinfo);
				// 优先取接口返回的 accessToken，回跳时写成 token 参数。
				var accessToken = result.data.accessToken || result.data.AccessToken
					|| (result.data.accountinfo && (result.data.accountinfo.accessToken || result.data.accountinfo.AccessToken))
					|| '';
				// 登录成功后统一走安全回跳逻辑，避免旧页保留开放重定向。
				util.redirectToSafeReturnUrl(that.returnurl, that.$router, accessToken);
			}
			else{
				that.loginText=result.msg;
			}
		})
	}
</script>

<style lang="scss">
	
</style>
